import React, { useState } from "react";
import { Modal, Button, Table, Form } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const StockHistoryModal = ({ show, onHide, product, history }) => {
  // 🔥 Pindahkan useState ke bagian atas
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  // 🔥 Jika tidak ada produk yang dipilih, langsung return (setelah Hooks dipanggil)
  if (!product) return null;

  // 🔥 Filter history berdasarkan produk yang diklik
  const productHistory = history.filter((item) => item.productId === product.id);

  // 🔥 Filter berdasarkan rentang tanggal
  const filteredHistory = productHistory.filter((item) => {
    const itemDate = new Date(item.date);
    return (
      (!startDate || itemDate >= startDate) &&
      (!endDate || itemDate <= endDate)
    );
  });

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>📅 Stock History: {product.name}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* 🔥 Filter Tanggal */}
        <div className="d-flex gap-3 mb-3">
          <div>
            <Form.Label>Start Date</Form.Label>
            <DatePicker
              selected={startDate}
              onChange={(date) => setStartDate(date)}
              className="form-control"
              placeholderText="Select start date"
            />
          </div>
          <div>
            <Form.Label>End Date</Form.Label>
            <DatePicker
              selected={endDate}
              onChange={(date) => setEndDate(date)}
              className="form-control"
              placeholderText="Select end date"
            />
          </div>
        </div>

        {/* 🔥 Tabel History */}
        <Table striped bordered>
          <thead>
            <tr>
              <th>No</th>
              <th>Stock Change</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {filteredHistory.length > 0 ? (
              filteredHistory.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td className={item.change > 0 ? "text-success" : "text-danger"}>
                    {item.change > 0 ? `+${item.change}` : item.change}
                  </td>
                  <td>{item.date}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" className="text-center">No history available</td>
              </tr>
            )}
          </tbody>
        </Table>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default StockHistoryModal;
